module.exports = __webpack_public_path__ + "static/microsoft-4e43649c2446e209a9ba65cbb30b70ed.png";